import { render, staticRenderFns } from "./userClassSetting.vue?vue&type=template&id=ce7335ec&scoped=true&"
import script from "./userClassSetting.vue?vue&type=script&lang=js&"
export * from "./userClassSetting.vue?vue&type=script&lang=js&"
import style0 from "./userClassSetting.vue?vue&type=style&index=0&id=ce7335ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7335ec",
  null
  
)

export default component.exports